module.exports = __webpack_public_path__ + "img/button_language_no.6f36fbdb.svg";